import { Box, Stack } from "@mui/material";

interface StepIndicatorDotsProps {
  activeStep: number;
  totalSteps: number;
}

export function StepIndicatorDots(props: StepIndicatorDotsProps) {
  const { activeStep, totalSteps } = props;

  const ACTIVE_DOT_SIZE = 12;
  const INACTIVE_DOT_SIZE = 8;

  return (
    <Stack direction="row" spacing={3} justifyContent="center" alignItems="center">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          sx={(theme) => ({
            width: activeStep === index ? ACTIVE_DOT_SIZE : INACTIVE_DOT_SIZE,
            height: activeStep === index ? ACTIVE_DOT_SIZE : INACTIVE_DOT_SIZE,
            borderRadius: "50%",
            backgroundColor: theme.palette.primary.light,
            opacity: activeStep === index ? 1 : 0.2,
            transition: theme.transitions.create(["width", "height"], {
              duration: theme.transitions.duration.shorter,
              easing: theme.transitions.easing.easeInOut,
            }),
          })}
        />
      ))}
    </Stack>
  );
}
